import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic } from 'helper/axios'

export const getScheduleById = async ({ id, token }) => {
  try {
    return await clientPublic
      .get(
        `project/schedule/${id}`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getScheduleViewlog = async ({ id, token }) => {
  try {
    return await clientPublic
      .get(
        `project/schedule/log/${id}?limit=100&orderby=created_at|desc`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getFlowScheduleCheck = async ({ id, token }) => {
  try {
    return await clientPublic
      .get(
        `sprintflow/schedule/check?project_id=${id}`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const addSchedule = async ({ params, id, token }) => {
  try {
    return await clientPublic
      .post(`project/schedule/${id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const projectScheduleAutoEdit = async ({ params, id, token }) => {
  try {
    return await clientPublic
      .post(`project/schedule/auto/${id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const scheduleSubtaskEdit = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`project/schedule/subtask/${params.project_id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const scheduleSubtaskDelete = async ({ params, project_id, token }) => {
  try {
    return await clientPublic
      .delete(`project/schedule/subtask/${project_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },

        data: params,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
